// extracted by mini-css-extract-plugin
export default {"spinner":"VBSpinner_spinner__Chdu9","center":"VBSpinner_center__tknXk","page":"VBSpinner_page__9QnB6"};